module.exports = __webpack_public_path__ + "84611c67a314978844446e06a07ac4b7.svg";